import { Button } from "primereact/button";
import { Tag } from "primereact/tag";
import { useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { Divider } from "primereact/divider";
import { Card } from "primereact/card";
import { Accordion, AccordionTab } from "primereact/accordion";
import familyAPI from "../../../services/family";
import trainingsAPI from "../../../services/trainings";
import RegistrationCard from "./RegistrationCard";
import FamilyStudentList from "./FamilyStudentList";
import HelloAssoPayButton from "./HelloAssoPayButton";
import AddNewRegistration from "../modals/AddNewRegistration";
import EditRegistration from "../modals/EditRegistration";

import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';
import { Toast } from "primereact/toast";
import EditRepresentativesModal from "../modals/EditRepresentativesModal";
import FamilyCreateSlotChangeRequestModal from "./FamilyCreateSlotChangeRequestModal";
import FamilyStudentObservationsModal from "./FamilyStudentObservationsModal";
import { formatSlotLabel, slotsForClass, studentClassId } from "../../trainings/slot-change-requests/slotChangeUtils";
import "./FamilyRegistration.css";
const FamilyRegistration = ({ accessToken, openObservationsForStudentId }) => {

  const [school, setSchool] = useState(null);
  const [training, setTraining] = useState(null);
  const [father, setFather] = useState(null);
  const [mother, setMother] = useState(null);
  const [parentsDivorced, setParentsDivorced] = useState(false);
  const [contactPerson1, setContactPerson1] = useState(null);
  const [contactPerson2, setContactPerson2] = useState(null);
  const [registrations, setRegistrations] = useState([]);
  const [contracts, setContracts] = useState([]);
  const [paymentSettings, setPaymentSettings] = useState(null);
  const [agenda, setAgenda] = useState([]);
  const [showPastEvents, setShowPastEvents] = useState(false);
  const [showAllUpcoming, setShowAllUpcoming] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [startingHelloAssoForContractId, setStartingHelloAssoForContractId] = useState(null);
  const [startingHelloAssoInstallments, setStartingHelloAssoInstallments] = useState(1);
  const [paymentHelpVisible, setPaymentHelpVisible] = useState(false);
  const [paymentHelpMethod, setPaymentHelpMethod] = useState(null);
  const [selectedContractForHelp, setSelectedContractForHelp] = useState(null);
  const [showSeeMore, setShowSeeMore] = useState(false);
  const [studentAvatarRefreshTokens, setStudentAvatarRefreshTokens] = useState({});
  const [showHelloAssoAmountModal, setShowHelloAssoAmountModal] = useState(false);
  const [selectedContractForAmount, setSelectedContractForAmount] = useState(null);
  const [helloAssoPaymentAmount, setHelloAssoPaymentAmount] = useState(null);
  const [familySlotChangeRequests, setFamilySlotChangeRequests] = useState([]);
  const [familySlotChangeData, setFamilySlotChangeData] = useState(null);
  const [slotChangeRequestsLoading, setSlotChangeRequestsLoading] = useState(false);
  const editRepresentativesModalRef = useRef(null);
  const addNewRegistrationRef = useRef(null);
  const editRegistrationRef = useRef(null);
  const messageContentRef = useRef(null);
  const accordionRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(null);
  const [refresh, setRefresh] = useState(new Date());
  const canEditInformations = training?.registration_allow_edit_informations !== false;
  const canEditStudentPhotos = training?.registration_allow_edit_student_photos !== false;
  const familySlotChangeEnabled = training?.registration_allow_slot_change_requests === true;
  const slotChangeRequestModalRef = useRef(null);
  const observationsModalRef = useRef(null);
  const observationsDeepLinkHandledRef = useRef(false);

  useEffect(() => {
    if (accessToken) {
      setSlotChangeRequestsLoading(true);
      // load family registration
      familyAPI.GetFamilyRegistration(accessToken).then(async (res) => {
        setSchool(res?.data?.school);
        setTraining(res?.data?.training);
        setFather(res?.data?.father || null);
        setMother(res?.data?.mother || null);
        setParentsDivorced(res?.data?.parents_divorced || false);
        setContactPerson1(res?.data?.contact_person_1);
        setContactPerson2(res?.data?.contact_person_2);
        setRegistrations(res?.data?.registrations);
        setContracts(res?.data?.contracts || []);
        setAgenda(res?.data?.agenda || []);
        setFamilySlotChangeRequests(res?.data?.slot_change_requests || []);
        setFamilySlotChangeData(res?.data?.slot_change_data || null);

        const schoolId = res?.data?.school?.id;
        const trainingId = res?.data?.training?.id;
        if (res?.data?.payment_settings) {
          setPaymentSettings(res?.data?.payment_settings);
        } else if (schoolId && trainingId) {
          try {
            const paymentSettingsRes = await trainingsAPI.GetPaymentSettings(schoolId, trainingId, accessToken);
            setPaymentSettings(paymentSettingsRes?.data || null);
          } catch {
            setPaymentSettings(null);
          }
        } else {
          setPaymentSettings(null);
        }
      }).catch((err) => {
        console.log("err", err);
        setFamilySlotChangeRequests([]);
        toast.current.show({ 
          severity: 'error', 
          summary: 'Erreur de chargement', 
          detail: err?.response?.data?.message || err?.message || 'Une erreur est survenue lors du chargement des données.', 
          life: 5000 
        });
      }).finally(() => {
        setSlotChangeRequestsLoading(false);
      });
    } else {
      setFamilySlotChangeRequests([]);
      setSlotChangeRequestsLoading(false);
    }
  }, [accessToken, refresh]);

  // Deep link from the observation email (?obs=<studentId>)
  useEffect(() => {
    if (!openObservationsForStudentId || observationsDeepLinkHandledRef.current) {
      return;
    }
    if (registrations?.some((item) => item?.id === openObservationsForStudentId)) {
      observationsDeepLinkHandledRef.current = true;
      observationsModalRef.current?.show(openObservationsForStudentId);
    }
  }, [openObservationsForStudentId, registrations]);

  // Check if content overflows to show/hide "Voir plus" button
  useEffect(() => {
    const checkOverflow = () => {
      if (messageContentRef.current) {
        const element = messageContentRef.current;
        const isOverflowing = element.scrollHeight > element.clientHeight;
        setShowSeeMore(isOverflowing);
      }
    };

    // Check overflow after content is loaded
    if (training?.registration_message) {
      // Use setTimeout to ensure DOM is updated
      setTimeout(checkOverflow, 100);
    }
  }, [training?.registration_message, expanded]);



  const toast = useRef(null);

  const acceptConfirmaRegistration = (event, student) => {
    familyAPI.ConfirmRegistration(accessToken, student?.id).then((res) => {
      setRefresh(new Date());
      if (canEditInformations) {
        editRegistrationRef.current.show(student, "Vous avez confirmé l\'inscription. Merci de vérifier et/ou mettre à jour les informations si nécessaire.", "success");
      } else {
        toast.current.show({
          severity: 'success',
          summary: 'Inscription confirmée',
          detail: 'La modification des informations est désactivée pour cette formation.',
          life: 3500,
        });
      }
    }).catch((err) => {
      console.log("err", err);
      toast.current.show({ 
        severity: 'error', 
        summary: 'Erreur de confirmation', 
        detail: err?.response?.data?.message || err?.message || 'Une erreur est survenue lors de la confirmation de l\'inscription.', 
        life: 5000 
      });
    });
  };

  const acceptUnregisterRegistration = (event, student) => {
    familyAPI.UnregisterRegistration(accessToken, student?.id, "").then((res) => {
      setRefresh(new Date());
      editRegistrationRef.current.show(res?.data, "Veuillez nous laisser un message pour nous en dire plus sur les raisons de votre décision.", "warn");
    }).catch((err) => {
      console.log("err", err);
      toast.current.show({ 
        severity: 'error', 
        summary: 'Erreur de désinscription', 
        detail: err?.response?.data?.message || err?.message || 'Une erreur est survenue lors de la désinscription.', 
        life: 5000 
      });
    });
  };

  const confirmRegistration = (event, student) => {
    confirmPopup({
      target: event.currentTarget,
      message: 'Voulez-vous vraiment confirmer l\'inscription ?',
      icon: 'pi pi-exclamation-triangle',
      defaultFocus: 'accept',
      acceptLabel: 'Confirmer',
      rejectLabel: 'Annuler',
      acceptClassName: 'p-button-success',
      accept: (event) => {
        acceptConfirmaRegistration(event, student);
      }
    });
  };

  const unregisterRegistration = (event, student) => {
    confirmPopup({
      target: event.currentTarget,
      message: 'Voulez-vous vraiment désinscrire l\'inscription ?',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Confirmer',
      rejectLabel: 'Annuler',
      acceptClassName: 'p-button-danger',
      accept: (event) => {
        acceptUnregisterRegistration(event, student);
      }
    });
  };

  const getSlotChangeRequestStatusLabel = (status) => {
    switch (status) {
      case 'PENDING':
        return 'En attente';
      case 'DRIFTED':
        return 'Dérivée';
      case 'APPROVED':
        return 'Approuvée';
      case 'REJECTED':
        return 'Refusée';
      case 'CANCELLED':
        return 'Annulée';
      default:
        return status || 'En attente';
    }
  };

  const handleDeleteFamilySlotChangeRequest = (requestId) => {
    confirmPopup({
      target: document.body,
      message: 'Voulez-vous vraiment supprimer cette demande de changement de créneau ?',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Supprimer',
      rejectLabel: 'Annuler',
      acceptClassName: 'p-button-danger',
      accept: async () => {
        try {
        await familyAPI.DeleteSlotChangeRequest(accessToken, requestId);
          setRefresh(new Date());
          toast.current.show({
            severity: 'success',
            summary: 'Demande supprimée',
            detail: 'La demande a bien été supprimée.',
            life: 3000,
          });
        } catch (err) {
          toast.current.show({
            severity: 'error',
            summary: 'Erreur',
            detail: err?.message || 'Impossible de supprimer la demande.',
            life: 4000,
          });
        }
      },
    });
  };

  const updateStudentPhoto = (student, file) => {
    if (!student?.id || !file) {
      return;
    }

    if (!canEditStudentPhotos) {
      toast.current.show({
        severity: 'warn',
        summary: 'Action non autorisée',
        detail: 'La modification des photos est désactivée pour cette formation.',
        life: 3500,
      });
      return;
    }

    setLoading(true);
    familyAPI.UpdateStudentPhoto(accessToken, student.id, file)
      .then(() => {
        setStudentAvatarRefreshTokens((prev) => ({
          ...prev,
          [student.id]: Date.now(),
        }));
        setRefresh(new Date());
        toast.current.show({
          severity: 'success',
          summary: 'Photo mise a jour',
          detail: 'La photo de l\'eleve a bien ete mise a jour.',
          life: 3000,
        });
      })
      .catch((err) => {
        toast.current.show({
          severity: 'error',
          summary: 'Erreur',
          detail: err?.message || 'Impossible de mettre a jour la photo pour le moment.',
          life: 5000,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const preregisteredCount = registrations?.filter((student) => student?.status === "PREREGISTRED")?.length || 0;
  const enrolledCount = registrations?.filter((student) => student?.status === "ENROLLED")?.length || 0;
  const waitingCount = registrations?.filter((student) => student?.status === "WAITING_LIST")?.length || 0;
  const unregisteredCount = registrations?.filter((student) => student?.status === "UNREGISTRED")?.length || 0;

  const paymentMethodMeta = {
    CASH: { label: "Espèces", icon: "pi pi-money-bill", kind: "onsite" },
    CB: { label: "Carte bancaire", icon: "pi pi-credit-card", kind: "onsite" },
    CHEQUE: { label: "Chèque", icon: "pi pi-wallet", kind: "onsite" },
    HELLOASSO: { label: "HelloAsso", icon: "pi pi-globe", kind: "online" },
    OTHER: { label: "Autre", icon: "pi pi-ellipsis-h", kind: "onsite" },
  };

  const isPaymentMethodEnabled = (methodId) => {
    if (!paymentSettings) return false;
    const map = {
      CASH: paymentSettings.cache_enabled,
      CB: paymentSettings.cb_enabled,
      CHEQUE: paymentSettings.cheque_enabled,
      HELLOASSO: paymentSettings.helloasso_enabled &&
                 paymentSettings.helloasso_system_disabled !== true &&
                 paymentSettings.helloasso_is_cach_in_compliant === true,
      OTHER: paymentSettings.other_enabled,
    };
    return Boolean(map[methodId]);
  };

  const availablePaymentMethods = Object.keys(paymentMethodMeta).filter((methodId) => isPaymentMethodEnabled(methodId));

  const parseAmount = (value) => {
    const n = Number(value);
    return Number.isFinite(n) ? n : 0;
  };

  const amountFloatToCents = (value) => {
    const amount = parseAmount(value);
    return Math.round(amount * 100);
  };

  const formatAmount = (value) => {
    const amount = parseAmount(value);
    return amount.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  const formatDate = (value) => {
    if (!value) return "-";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "-";
    return d.toLocaleDateString("fr-FR");
  };

  const getContractPayments = (contract) => {
    if (Array.isArray(contract?.payments)) return contract.payments;
    if (Array.isArray(contract?.payment_list)) return contract.payment_list;
    if (Array.isArray(contract?.history?.payments)) return contract.history.payments;
    return [];
  };

  const getPaymentMethodLabel = (method) => paymentMethodMeta[method]?.label || method || "-";

  const getPaymentStatusTag = (status) => {
    if (status === "PAID" || status === "paid") return { value: "Payé", severity: "success" };
    if (status === "PENDING" || status === "pending") return { value: "En attente", severity: "warning" };
    if (status === "FAILED" || status === "failed") return { value: "Échoué", severity: "danger" };
    return { value: "Inconnu", severity: "info" };
  };

  const getRemainingAmount = (contract) => {
    const total = parseAmount(contract?.total_amount);
    const paid = parseAmount(contract?.paid_balance);
    const remaining = total - paid;
    return remaining > 0 ? remaining : 0;
  };

  const openSchoolPaymentHelp = (methodId, contract) => {
    setPaymentHelpMethod(methodId);
    setSelectedContractForHelp(contract);
    setPaymentHelpVisible(true);
  };

  const extractHelloAssoCheckoutData = (payload) => {
    const data = payload?.data || {};
    return {
      checkoutIntentId: data?.checkout_intent_id || null,
      redirectUrl: data?.redirect_url || null,
      eventId: data?.event_id || null,
    };
  };

  const openHelloAssoAmountModal = (contract) => {
    if (!contract?.id) return;

    const remainingAmount = getRemainingAmount(contract);
    if (remainingAmount <= 0) {
      toast.current.show({
        severity: "info",
        summary: "Déjà réglé",
        detail: "Ce contrat est déjà entièrement payé.",
        life: 3000,
      });
      return;
    }

    setSelectedContractForAmount(contract);
    setHelloAssoPaymentAmount(remainingAmount);
    setShowHelloAssoAmountModal(true);
  };

  const buildHelloAssoUrls = () => {
    const currentUrl = window.location.href;
    const baseUrl = window.location.origin;
    //const baseUrl = process.env.REACT_APP_HELLOASSO_RETURN_URL;
    const encodedBackUrl = encodeURIComponent(currentUrl);

    return {
      backUrl: process.env.REACT_APP_HELLOASSO_RETURN_URL || currentUrl,
      returnUrl: process.env.REACT_APP_HELLOASSO_RETURN_URL || `${baseUrl}/family/helloasso/return?back_url=${encodedBackUrl}`,
      errorUrl: process.env.REACT_APP_HELLOASSO_RETURN_URL || `${baseUrl}/family/helloasso/error?back_url=${encodedBackUrl}`,
    };
  };

  const handlePayContract = async (contract, methodId, amount = null, installments = 1) => {
    if (!contract?.id) return;

    if (methodId !== "HELLOASSO") {
      openSchoolPaymentHelp(methodId, contract);
      return;
    }

    const schoolId = school?.id;
    const trainingId = training?.id;
    if (!schoolId || !trainingId) {
      toast.current.show({ severity: "error", summary: "Erreur", detail: "Contexte de formation introuvable.", life: 3000 });
      return;
    }

    const remainingAmount = getRemainingAmount(contract);
    if (remainingAmount <= 0) {
      toast.current.show({
        severity: "info",
        summary: "Déjà réglé",
        detail: "Ce contrat est déjà entièrement payé.",
        life: 3000,
      });
      return;
    }

    const paymentAmount = amount || remainingAmount;
    if (paymentAmount <= 0 || paymentAmount > remainingAmount) {
      toast.current.show({
        severity: "error",
        summary: "Montant invalide",
        detail: "Le montant doit être entre 0.01€ et " + formatAmount(remainingAmount) + "€.",
        life: 3000,
      });
      return;
    }

    let navigatingToHelloAsso = false;
    try {
      setStartingHelloAssoForContractId(contract.id);
      setStartingHelloAssoInstallments(installments);

      const payerSource = father || mother || {};
      const payer = {
        id: payerSource?.id || null,
        firstname: payerSource?.firstname || null,
        lastname: payerSource?.lastname || null,
        email: payerSource?.email || null,
        phone: payerSource?.phone || null,
      };

      const metadata = {
        school_id: schoolId,
        training_id: trainingId,
        contract_id: contract.id,
        amount_cents: amountFloatToCents(paymentAmount),
      };

      const helloAssoUrls = buildHelloAssoUrls();

      const result = await familyAPI.InitHelloAssoPayment(accessToken, {
        contract_id: contract.id,
        amount: paymentAmount,
        contains_donation: false,
        back_url: helloAssoUrls.backUrl,
        return_url: helloAssoUrls.returnUrl,
        error_url: helloAssoUrls.errorUrl,
        payer,
        metadata,
        installments: installments,
      });

      const checkoutData = extractHelloAssoCheckoutData(result);
      const redirectUrl = checkoutData?.redirectUrl;
      if (redirectUrl) {
        navigatingToHelloAsso = true;
        window.location.href = redirectUrl;
      } else {
        toast.current.show({
          severity: "info",
          summary: "Paiement initié",
          detail: "Le paiement a été initié, mais aucune URL de redirection (data.redirect_url) n'a été renvoyée.",
          life: 3500,
        });
        setRefresh(new Date());
      }
    } catch (err) {
      toast.current.show({
        severity: "error",
        summary: "Erreur HelloAsso",
        detail: err?.message || "Impossible d'initier le paiement HelloAsso.",
        life: 4000,
      });
    } finally {
      if (!navigatingToHelloAsso) {
        setStartingHelloAssoForContractId(null);
        setStartingHelloAssoInstallments(1);
        setShowHelloAssoAmountModal(false);
      }
    }
  };

  const handleNavClick = (index) => {
    setActiveIndex(index);
    if (accordionRef.current) {
      const element = accordionRef.current;
      const desktopOffset = 100;
      const mobileOffset = 30;
      const offset = window.innerWidth >= 769 ? desktopOffset : mobileOffset;
      const top = element.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: Math.max(top, 0), behavior: "smooth" });
    }
  };

  const renderAccordion = () => {
    return (
      <div ref={accordionRef}>
        <Accordion className="family-registration-accordion" activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
        {familySlotChangeEnabled && (
          <AccordionTab header={<span className="flex align-items-center gap-2 mea-gradient-text"><i className="pi pi-sync"></i><span>Changement de créneaux</span></span>}>
            <div className="family-section-card surface-section px-3 py-3">
              <div className="flex justify-content-between align-items-center mb-3 gap-3 flex-wrap">
                <Button
                  label="Nouvelle demande"
                  icon="pi pi-plus"
                  size="small"
                  onClick={() => slotChangeRequestModalRef.current?.show(() => setRefresh(new Date()))}
                />
              </div>

              {slotChangeRequestsLoading ? (
                <div className="text-center py-4 text-500">Chargement des demandes...</div>
              ) : (() => {
                const myRequests = (familySlotChangeRequests || []).filter((request) =>
                  registrations.some((student) => student.id === request.student_id)
                );

                if (!myRequests.length) {
                  return (
                    <div className="text-center py-4 text-500">
                      Aucune demande de changement de créneau pour le moment.
                    </div>
                  );
                }

                return (
                  <div className="flex flex-column gap-3">
                    {myRequests.map((request) => {
                      const student = registrations.find((item) => item.id === request.student_id);
                      const preferredSlots = Array.isArray(request?.preferences) ? request.preferences : [];
                      const canDelete = ["PENDING", "DRIFTED"].includes(request.status);
                      const isApproved = request?.status === "APPROVED";

                      const sourceClassName = request?.from_class?.name || request?.from_class_name || student?.classe?.name || student?.class_name || student?.class?.name || "-";
                      const sourceSlots = Array.isArray(request?.from_slot)
                        ? request.from_slot
                        : request?.from_slot
                          ? [request.from_slot]
                          : slotsForClass({
                              slots: familySlotChangeData?.slots || [],
                              scheduleItems: familySlotChangeData?.schedule_items || [],
                              classId: studentClassId(student),
                            });

                      const classLabel = isApproved ? "Classe d'origine" : "Classe actuelle";
                      const slotLabel = isApproved ? "Créneau d'origine" : "Créneau actuel";
                      const approvedCurrentSlots = isApproved
                        ? slotsForClass({
                            slots: familySlotChangeData?.slots || [],
                            scheduleItems: familySlotChangeData?.schedule_items || [],
                            classId: request?.approved_class_id || studentClassId(student),
                          })
                        : [];
                      const approvedCurrentSlotIds = new Set(
                        approvedCurrentSlots
                          .map((slot) => slot?.id)
                          .filter((slotId) => Boolean(slotId))
                      );

                      return (
                        <div key={request.id} className="p-3 border-1 border-gray-200 border-round bg-white">
                          <div className="flex justify-content-between align-items-start gap-3 flex-wrap">
                            <div>
                              <div className="font-medium text-900">
                                {student ? `${student.firstname || ""} ${student.lastname || ""}`.trim() || "Élève" : "Élève"}
                              </div>
                              <small className="text-500">
                                Demande du {new Date(request.requested_at).toLocaleDateString("fr-FR")}
                              </small>
                            </div>
                            <div className="flex align-items-center gap-2 flex-wrap">
                              <Tag value={getSlotChangeRequestStatusLabel(request.status)} severity={request.status === 'REJECTED' ? 'danger' : request.status === 'APPROVED' ? 'success' : 'info'} />
                              {canDelete && (
                                <Button
                                  icon="pi pi-trash"
                                  text
                                  severity="danger"
                                  aria-label="Supprimer la demande"
                                  onClick={() => handleDeleteFamilySlotChangeRequest(request.id)}
                                />
                              )}
                            </div>
                          </div>

                          <div className="mt-2 text-sm text-600">
                            {classLabel} : <span className="font-medium text-900">{sourceClassName}</span>
                          </div>
                          <div className="mt-1 text-sm text-600">
                            {slotLabel} : <span className="font-medium text-900">{sourceSlots.length ? sourceSlots.map((slot) => formatSlotLabel(slot)).join(", ") : "Aucun créneau"}</span>
                          </div>
                          <div className="mt-2 text-sm text-600">
                            Créneaux demandés :
                            <div className="font-medium text-900 mt-1">
                              {preferredSlots.length ? preferredSlots.map((pref, index) => {
                                const slot = pref?.slot || pref;
                                const slotLabelText = slot?.name ? formatSlotLabel(slot) : `Créneau ${index + 1}`;
                                const isChosenSlot = isApproved && slot?.id && approvedCurrentSlotIds.has(slot.id);
                                return (
                                  <div
                                    key={`${request.id}-pref-${slot?.id || index}`}
                                    className={`flex align-items-center gap-2 ${isChosenSlot ? "text-green-500" : ""}`}
                                  >
                                    <span>{`${index + 1}. ${slotLabelText}`}</span>
                                    {isChosenSlot && (
                                      <i
                                        className="pi pi-check-circle text-green-500"
                                        title="Créneau effectivement choisi"
                                        aria-label="Créneau effectivement choisi"
                                      />
                                    )}
                                  </div>
                                );
                              }) : "Aucun créneau souhaité renseigné."}
                            </div>
                          </div>
                          {request.status === "REJECTED" ? (
                            <>
                              {request.reason && (
                                <div className="mt-2 text-sm text-600">
                                  Demande : {request.reason}
                                </div>
                              )}
                              {request.rejection_reason && (
                                <div className="mt-2 text-sm text-600">
                                  Motif du refus : <span className="font-bold text-red-500">{request.rejection_reason}</span>
                                </div>
                              )}
                            </>
                          ) : request.reason ? (
                            <div className="mt-2 text-sm text-600">
                              Motif : {request.reason}
                            </div>
                          ) : null}
                        </div>
                      );
                    })}
                  </div>
                );
              })()}
            </div>
          </AccordionTab>
        )}
        <AccordionTab header={<span className="flex align-items-center gap-2 mea-gradient-text"><i className="pi pi-info-circle"></i><span>Informations</span></span>}>
          {training?.registration_message && (
            <>

              <div className="family-section-card surface-section px-2 md:px-3 lg:px-3">
                <div className="mb-1 ">
                  <div 
                    ref={messageContentRef}
                    style={{ maxHeight: expanded ? 'none' : '250px', overflow: 'hidden', position: 'relative' }}
                    dangerouslySetInnerHTML={{ __html: training?.registration_message }}>
                  </div>
                  {!expanded && training?.registration_message?.length > 0 && showSeeMore && (
                    <div className="text-center mt-3">
                        <Button label="Voir plus" text outlined className="family-ghost-btn" onClick={() => setExpanded(true)} />
                    </div>
                  )}
                  {expanded && (
                    <div className="text-center mt-3">
                        <Button label="Voir moins" text outlined className="family-ghost-btn" onClick={() => setExpanded(false)} />
                    </div>
                  )}
                </div>
              </div>
            </>
          )}

          {/* Agenda */}
          {agenda && agenda.length > 0 && (
            <>
              <div className="flex flex-column mb-3 mt-5">
                <div className="family-section-title">Agenda</div>
              </div>
              <div className="family-section-card bg-white border-round border-1 border-300 overflow-hidden">
                <div className="flex flex-column p-4">
                  {(() => {
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);

                    const visibleEventTypes = ["MEETING", "VACATION", "BANK_HOLIDAY", "OTHER"];
                    const visibleEvents = agenda.filter((event) => visibleEventTypes.includes(event.event_type));

                    const upcomingEvents = visibleEvents.filter((event) => new Date(event.start_date) >= today)
                      .sort((a, b) => new Date(a.start_date) - new Date(b.start_date));

                    const pastEvents = visibleEvents.filter((event) => new Date(event.start_date) < today)
                      .sort((a, b) => new Date(a.start_date) - new Date(b.start_date));

                    const upcomingToShow = showAllUpcoming ? upcomingEvents : upcomingEvents.slice(0, 3);

                    const eventsToShow = showPastEvents
                      ? [...pastEvents, ...upcomingToShow].sort((a, b) => new Date(a.start_date) - new Date(b.start_date))
                      : upcomingToShow;

                    return (
                      <>
                        {eventsToShow.map((event, index) => {
                          const isPastEvent = new Date(event.start_date) < today;

                          const getEventColors = (eventType) => {
                            switch (eventType) {
                              case "MEETING":
                                  return { bar: "bg-purple-400", bg: "bg-purple-100" };
                              case "VACATION":
                              case "BANK_HOLIDAY":
                                  return { bar: "bg-green-400", bg: "bg-green-100" };
                              default:
                                  return { bar: "bg-blue-400", bg: "bg-blue-100" };
                            }
                          };

                          const colors = isPastEvent ? { bar: "bg-gray-300", bg: "bg-gray-200" } : getEventColors(event.event_type);

                          return (
                            <div key={event.id}>
                              <div className="flex align-items-start gap-4 py-3">
                                <div className="flex flex-column align-items-center" style={{ minWidth: "80px" }}>
                                  <div className="relative">
                                    <div
                                      className={`w-2 h-8 border-round ${colors.bar}`}
                                      style={{
                                        position: "absolute",
                                        left: "-8px",
                                        top: "0",
                                      }}
                                    ></div>
                                    <div className={`border-round p-3 text-center ${colors.bg}`} style={{ minWidth: "60px" }}>
                                      <div className={`text-lg font-bold ${isPastEvent ? "text-600" : "text-900"}`}>
                                        {new Date(event.start_date).getDate()}
                                      </div>
                                      <div className={`text-xs font-medium ${isPastEvent ? "text-500" : "text-600"}`}>
                                        {new Date(event.start_date).toLocaleDateString("fr-FR", { month: "short" })}
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="flex-1">
                                  <div className="flex flex-column gap-1">
                                    <div className={`font-bold text-lg ${isPastEvent ? "text-600" : "text-900"}`}>{event.name}</div>
                                    <div className={`text-sm ${isPastEvent ? "text-500" : "text-900"}`}>
                                      {(() => {
                                        const startDate = new Date(event.start_date);
                                        const endDate = new Date(event.end_date);
                                        const isSameDay = startDate.toDateString() === endDate.toDateString();

                                        if (isSameDay) {
                                          return `Le ${startDate.toLocaleDateString("fr-FR", {
                                            weekday: "long",
                                            day: "numeric",
                                            month: "long",
                                          })}`;
                                        }

                                        return `Du ${startDate.toLocaleDateString("fr-FR", {
                                          weekday: "long",
                                          day: "numeric",
                                          month: "long",
                                        })} au ${endDate.toLocaleDateString("fr-FR", {
                                          weekday: "long",
                                          day: "numeric",
                                          month: "long",
                                        })}`;
                                      })()}
                                    </div>
                                    <div className={`text-sm ${isPastEvent ? "text-400" : "text-600"}`}>
                                      {event.event_type === "MEETING"
                                        ? "Réunion"
                                        : event.event_type === "VACATION"
                                        ? "Vacances"
                                        : event.event_type === "BANK_HOLIDAY"
                                        ? "Jours fériés"
                                        : "Événement"}
                                    </div>
                                    {event.presentation && (
                                      <div className={`text-sm mt-2 p-2 border-round ${isPastEvent ? "text-400 bg-gray-100" : "text-500 bg-gray-50"}`}>
                                        {event.presentation}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                              {index < eventsToShow.length - 1 && <div className="border-top-1 border-gray-200"></div>}
                            </div>
                          );
                        })}

                        <div className="flex justify-content-center gap-2 mt-4">
                          {!showAllUpcoming && upcomingEvents.length > 3 && (
                            <Button
                              label={`Voir plus d'événements (${upcomingEvents.length - 3} restants)`}
                              text
                              size="small"
                              onClick={() => setShowAllUpcoming(true)}
                            />
                          )}
                          {showAllUpcoming && upcomingEvents.length > 3 && (
                            <Button
                              label="Voir moins d'événements"
                              text
                              size="small"
                              onClick={() => setShowAllUpcoming(false)}
                            />
                          )}
                          {!showPastEvents && pastEvents.length > 0 && (
                            <Button
                              label={`Voir les événements passés (${pastEvents.length})`}
                              text
                              size="small"
                              onClick={() => setShowPastEvents(true)}
                            />
                          )}
                          {showPastEvents && (
                            <Button
                              label="Masquer les événements passés"
                              text
                              size="small"
                              onClick={() => setShowPastEvents(false)}
                            />
                          )}
                        </div>
                      </>
                    );
                  })()}
                </div>
              </div>
            </>
          )}
        </AccordionTab>

        <AccordionTab header={<span className="flex align-items-center gap-2 mea-gradient-text"><i className="pi pi-users"></i><span>Responsables légaux</span></span>}>
          <div className="family-section-card family-legal-section-card bg-white border-round border-1 border-300 overflow-hidden mt-2">
            <div className="grid m-0 p-0 family-legal-grid" style={{ minHeight: "200px" }}>
              <div className="col-12 lg:col-8 p-3 flex flex-column family-legal-main-col" style={{ minHeight: "200px" }}>
                <div className="family-parents-grid flex-1">
                  <div className="family-parent-cell">
                    <div className="family-parent-card">
                      <div className="family-parent-head">
                        <div className="family-parent-icon family-parent-icon-father">
                          <i className="pi pi-user"></i>
                        </div>
                        <div className="flex flex-column">
                          <span className="family-parent-role">Père</span>
                          <span className="family-parent-name">{((father?.lastname || "") + " " + (father?.firstname || "")).trim() || "-"}</span>
                        </div>
                      </div>
                      <div className="family-contacts-list">
                        <div className="family-parent-contact">
                          <i className="pi pi-phone"></i>
                          <span>{father?.phone || "-"}</span>
                        </div>
                        <div className="family-parent-contact">
                          <i className="pi pi-envelope"></i>
                          <span>{father?.email || "-"}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="family-parent-cell">
                    <div className="family-parent-card">
                      <div className="family-parent-head">
                        <div className="family-parent-icon family-parent-icon-mother">
                          <i className="pi pi-user"></i>
                        </div>
                        <div className="flex flex-column">
                          <span className="family-parent-role">Mère</span>
                          <span className="family-parent-name">{((mother?.lastname || "") + " " + (mother?.firstname || "")).trim() || "-"}</span>
                        </div>
                      </div>
                      <div className="family-contacts-list">
                        <div className="family-parent-contact">
                          <i className="pi pi-phone"></i>
                          <span>{mother?.phone || "-"}</span>
                        </div>
                        <div className="family-parent-contact">
                          <i className="pi pi-envelope"></i>
                          <span>{mother?.email || "-"}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="family-legal-edit-wrap">
                  <Button
                    label="Modifier"
                    icon="pi pi-pencil"
                    className="w-full family-ghost-btn"
                    size="small"
                    text
                    raised
                    disabled={!canEditInformations}
                    onClick={() => {
                      editRepresentativesModalRef.current.show(father, mother, parentsDivorced, contactPerson1, contactPerson2);
                    }}
                  />
                </div>
              </div>

              <div className="col-12 lg:col-4 p-3 family-legal-side-col" style={{ minHeight: "200px" }}>
                <div className="family-legal-side-card">
                  <div className="flex flex-column gap-2">
                    <h6 className="text-sm font-bold text-700 m-0 flex align-items-center gap-2 mb-1">
                      <i className="pi pi-heart text-xs"></i>
                      Situation familiale
                    </h6>
                    <div className="family-parent-contact">
                      <i className={`pi ${parentsDivorced ? "pi-times-circle" : "pi-check-circle"}`}></i>
                      <span>{parentsDivorced ? "Divorcés" : "Mariés"}</span>
                    </div>
                  </div>

                  <div className="flex flex-column gap-2 mt-3">
                    <h6 className="text-sm font-bold text-700 m-0 flex align-items-center gap-2 mb-1">
                      <i className="pi pi-phone text-xs"></i>
                      Contacts d'urgence
                    </h6>
                    <div className="family-contacts-list">
                      {(contactPerson1?.name || contactPerson1?.phone) && (
                        <div className="family-parent-contact">
                          <i className="pi pi-user"></i>
                          <span>{[contactPerson1?.name, contactPerson1?.phone].filter(Boolean).join(" - ")}</span>
                        </div>
                      )}
                      {(contactPerson2?.name || contactPerson2?.phone) && (
                        <div className="family-parent-contact">
                          <i className="pi pi-user"></i>
                          <span>{[contactPerson2?.name, contactPerson2?.phone].filter(Boolean).join(" - ")}</span>
                        </div>
                      )}
                      {!((contactPerson1?.name || contactPerson1?.phone) || (contactPerson2?.name || contactPerson2?.phone)) && (
                        <div className="family-parent-contact">
                          <i className="pi pi-info-circle"></i>
                          <span>Aucun contact supplémentaire</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </AccordionTab>

        <AccordionTab header={<span className="flex align-items-center gap-2 mea-gradient-text"><i className="pi pi-book"></i><span>Élèves</span></span>}>
          <FamilyStudentList
            students={registrations}
            className="family-students-grid flex flex-column gap-4 mt-2"
            renderStudent={(student) => (
              <RegistrationCard
                training={training}
                student={student}
                key={student?.id}
                editRegistrationRef={editRegistrationRef}
                confirmRegistration={confirmRegistration}
                unregisterRegistration={unregisterRegistration}
                onUpdateStudentPhoto={updateStudentPhoto}
                avatarRefreshToken={studentAvatarRefreshTokens[student?.id]}
                canEditInformations={canEditInformations}
                canEditStudentPhotos={canEditStudentPhotos}
                onShowObservations={(item) => observationsModalRef.current?.show(item?.id)}
              />
            )}
          />
          {/* New Registration Section */}
          {training?.registration_allow_new && (
            <div className="family-new-registration-card card mt-4">
              <div className="flex flex-column align-items-center p-4">
                <h3 className="text-lg font-bold mt-0 mb-3">Ajouter une nouvelle inscription</h3>
                <p className="text-500 text-center mb-4">
                  Vous pouvez faire une demande d'inscription pour un autre enfant en utilisant les mêmes informations de contact
                </p>
                <Button size="large" icon="pi pi-plus" loading={loading} label="Nouvelle inscription" className="p-button p-component p-button-primary family-primary-btn" onClick={() => {
                  addNewRegistrationRef.current.show();
                }} />
              </div>
            </div>
          )}
        </AccordionTab>

        <AccordionTab header={<span className="flex align-items-center gap-2 mea-gradient-text"><i className="pi pi-credit-card"></i><span>Paiements des cotisations</span></span>}>
          <div className="family-section-card family-payments-card overflow-hidden">
            <div className="flex flex-column">
              {training?.registration_allow_payments === false ? (
                <div className="family-payment-empty text-center py-4 m-3">
                  <i className="pi pi-info-circle text-3xl text-400 mb-2"></i>
                  <div className="text-500 text-sm">Les paiements des cotisations ne sont pas encore ouverts.</div>
                </div>
              ) : contracts && contracts?.length > 0 ? (
                <div className="flex flex-column family-payments-list">
                  {contracts?.map((contract, index) => (
                    <div key={contract?.id || index} className="p-4 family-payment-item">
                      <div className="grid">
                        <div className={`col-12 ${contract?.payment_status === "partial" ? "md:col-4" : "md:col-6"}`}>
                          <div className="flex flex-column gap-1">
                            <span className="family-payment-label">Montant total</span>
                            <span className="family-payment-value">€{contract?.total_amount || "0.00"}</span>
                          </div>
                        </div>
                        <div className={`col-12 ${contract?.payment_status === "partial" ? "md:col-4" : "md:col-6"}`}>
                          <div className="flex flex-column gap-1">
                            <span className="family-payment-label">Statut du paiement</span>
                            <div className="family-payment-status">
                              {contract?.payment_status === "paid" && (
                                <>
                                  <i className="pi pi-check-circle text-green-500"></i>
                                  <span className="font-medium text-green-600">Payé</span>
                                </>
                              )}
                              {contract?.payment_status === "partial" && (
                                <>
                                  <i className="pi pi-clock text-orange-500"></i>
                                  <span className="font-medium text-orange-600">Partiellement payé</span>
                                </>
                              )}
                              {contract?.payment_status === "pending" && (
                                <>
                                  <i className="pi pi-hourglass text-yellow-500"></i>
                                  <span className="font-medium text-yellow-600">En attente de paiement</span>
                                </>
                              )}
                              {!contract?.payment_status && (
                                <>
                                  <i className="pi pi-question-circle text-gray-500"></i>
                                  <span className="font-medium text-gray-600">Non défini</span>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                        {contract?.payment_status === "partial" && (
                          <div className="col-12 md:col-4">
                            <div className="flex flex-column gap-1">
                              <span className="family-payment-label">Montant reste à payer</span>
                              <span className="family-payment-value text-red-600">€{formatAmount(getRemainingAmount(contract))}</span>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="mt-3 pt-3 family-payment-footer">
                        <div className="flex align-items-center gap-2">
                          <i className="pi pi-file text-400"></i>
                          <span className="family-payment-contract">Contrat {contract?.id}</span>
                        </div>
                      </div>

                      {getRemainingAmount(contract) > 0 && (
                        <div className="mt-3 pt-3 border-top-1 border-gray-200">
                          {availablePaymentMethods.length > 0 ? (
                            <div className="flex flex-wrap gap-4 align-items-start">
                              <div>
                                <div className="text-600 font-medium mb-2">Paiement en ligne</div>
                                {availablePaymentMethods.includes("HELLOASSO") ? (
                                  <div className="flex justify-content-start">
                                    <HelloAssoPayButton
                                      key={`${contract?.id}-HELLOASSO`}
                                      onClick={() => openHelloAssoAmountModal(contract)}
                                      loading={startingHelloAssoForContractId === contract?.id}
                                      disabled={getRemainingAmount(contract) <= 0}
                                    />
                                  </div>
                                ) : (
                                  <small className="text-500">Le paiement en ligne n'est pas activé.</small>
                                )}
                              </div>

                              <div>
                                <div className="text-600 font-medium mb-2">Paiement sur place</div>
                                {availablePaymentMethods.filter((methodId) => methodId !== "HELLOASSO").length > 0 ? (
                                  <div className="flex flex-wrap gap-2">
                                    {availablePaymentMethods.filter((methodId) => methodId !== "HELLOASSO").map((methodId) => (
                                      <Button
                                        key={`${contract?.id}-${methodId}`}
                                        icon={paymentMethodMeta[methodId]?.icon}
                                        label={paymentMethodMeta[methodId]?.label}
                                        outlined
                                        onClick={() => handlePayContract(contract, methodId)}
                                      />
                                    ))}
                                  </div>
                                ) : (
                                  <small className="text-500">Aucun moyen de paiement sur place activé.</small>
                                )}
                              </div>
                            </div>
                          ) : (
                            <small className="text-500">Aucune méthode de paiement n'est activée actuellement.</small>
                          )}
                        </div>
                      )}

                      <div className="mt-3 pt-3 border-top-1 border-gray-200">
                        <div className="text-700 font-semibold mb-2">Historique des paiements</div>
                        {getContractPayments(contract).length > 0 ? (
                          <div className="flex flex-column gap-2">
                            {getContractPayments(contract).map((payment, paymentIndex) => {
                              const statusTag = getPaymentStatusTag(payment?.status);
                              return (
                                <div
                                  key={payment?.id || `${contract?.id}-payment-${paymentIndex}`}
                                  className="p-2 border-1 border-gray-200 border-round bg-white"
                                >
                                  <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-2">
                                    <div className="flex flex-column gap-1">
                                      <div className="font-medium text-900">{getPaymentMethodLabel(payment?.method)}</div>
                                      <small className="text-500">Réception: {formatDate(payment?.payment_received_date || payment?.created_at)}</small>
                                      <small className="text-500">Encaissement: {formatDate(payment?.payment_date)}</small>
                                    </div>
                                    <div className="flex align-items-center gap-2">
                                      <span className="font-semibold text-900">€{formatAmount(payment?.amount)}</span>
                                      <Tag value={statusTag.value} severity={statusTag.severity} />
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          <small className="text-500">Aucun paiement enregistré pour ce contrat.</small>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="family-payment-empty text-center py-4 m-3">
                  <i className="pi pi-credit-card text-3xl text-400 mb-2"></i>
                  <div className="text-500 text-sm">Aucun contrat de paiement</div>
                  <div className="text-400 text-xs mt-1">Les contrats seront bientôt disponibles</div>
                </div>
              )}
            </div>
          </div>
        </AccordionTab>
      </Accordion>
      </div>
    );
  };

  return (
    <div className="family-registration-page flex flex-column align-items-center w-full h-full">

      <div className="family-registration-shell w-full h-full">
        <div className="family-desktop-nav-bar">
          {familySlotChangeEnabled && (
            <Button 
              icon="pi pi-sync"
              label="Demandes"
              className={`p-button-text p-button-plain family-desktop-nav-button ${activeIndex === 0 ? "family-desktop-nav-button-active" : ""}`}
              onClick={() => handleNavClick(0)}
            />
          )}
          <Button 
            icon="pi pi-info-circle"
            label="Informations"
            className={`p-button-text p-button-plain family-desktop-nav-button ${activeIndex === (familySlotChangeEnabled ? 1 : 0) ? "family-desktop-nav-button-active" : ""}`}
            onClick={() => handleNavClick(familySlotChangeEnabled ? 1 : 0)}
          />
          <Button 
            icon="pi pi-users"
            label="Responsables légaux"
            className={`p-button-text p-button-plain family-desktop-nav-button ${activeIndex === (familySlotChangeEnabled ? 2 : 1) ? "family-desktop-nav-button-active" : ""}`}
            onClick={() => handleNavClick(familySlotChangeEnabled ? 2 : 1)}
          />
          <Button 
            icon="pi pi-book"
            label="Élèves"
            className={`p-button-text p-button-plain family-desktop-nav-button ${activeIndex === (familySlotChangeEnabled ? 3 : 2) ? "family-desktop-nav-button-active" : ""}`}
            onClick={() => handleNavClick(familySlotChangeEnabled ? 3 : 2)}
          />
          <Button 
            icon="pi pi-credit-card"
            label="Cotisations"
            className={`p-button-text p-button-plain family-desktop-nav-button ${activeIndex === (familySlotChangeEnabled ? 4 : 3) ? "family-desktop-nav-button-active" : ""}`}
            onClick={() => handleNavClick(familySlotChangeEnabled ? 4 : 3)}
          />
        </div>

        <FamilyStudentObservationsModal
          ref={observationsModalRef}
          accessToken={accessToken}
          students={registrations}
          onApproved={() => setRefresh(new Date())}
        />
        <FamilyCreateSlotChangeRequestModal
          ref={slotChangeRequestModalRef}
          schoolId={school?.id}
          trainingId={training?.id}
          accessToken={accessToken}
          students={registrations}
          slotChangeData={familySlotChangeData}
          onSubmitSuccess={() => setRefresh(new Date())}
        />
        <EditRepresentativesModal ref={editRepresentativesModalRef} school={school} training={training} callbackHandler={(father, mother, parentsDivorced, contactPerson1, contactPerson2) => {
          setLoading(true);
          familyAPI.UpdateContacts(accessToken, {
            father_id: father?.id || null,
            father_lastname: father?.lastname || null,
            father_firstname: father?.firstname || null,
            father_email: father?.email || null,
            father_phone: father?.phone || null,
            father_postal_code: father?.postal_code || null,
            mother_id: mother?.id || null,
            mother_lastname: mother?.lastname || null,
            mother_firstname: mother?.firstname || null,
            mother_email: mother?.email || null,
            mother_phone: mother?.phone || null,
            mother_postal_code: mother?.postal_code || null,
            parents_divorced: parentsDivorced,
            contact_person_1_name: contactPerson1?.name || null,
            contact_person_1_phone: contactPerson1?.phone || null,
            contact_person_2_name: contactPerson2?.name || null,
            contact_person_2_phone: contactPerson2?.phone || null,
          }).then((res) => {
            setRefresh(new Date());
            setLoading(false);
          }).catch((err) => {
            toast.current.show({ severity: 'error', summary: 'Erreur', detail: err?.message, life: 3000 });
            setLoading(false);
          });
        }} />
        <AddNewRegistration ref={addNewRegistrationRef} school={school} training={training} father={father} mother={mother} callbackHandler={(student) => {

          student.father_id = father?.id || null;
          student.mother_id = mother?.id || null;
          familyAPI.NewRegistration(accessToken, student).then((res) => {
            setLoading(false);
            setRefresh(new Date());
          }).catch((err) => {
            toast.current.show({ severity: 'error', summary: 'Erreur', detail: err?.message, life: 3000 });
            setLoading(false);
          });
        }} />
        <EditRegistration ref={editRegistrationRef} school={school} father={father} mother={mother} training={training} onDelete={(student) => {
          setLoading(true);
          familyAPI.DeleteRegistration(accessToken, student?.id).then((res) => {
            setLoading(false);
            setRefresh(new Date());
          }).catch((err) => {
            toast.current.show({ severity: 'error', summary: 'Erreur', detail: err?.message, life: 3000 });
            setLoading(false);
          });
        }}
          callbackHandler={(student) => {
            setLoading(true);
            familyAPI.UpdateRegistration(accessToken, student).then((res) => {
              setLoading(false);
              setRefresh(new Date());
            }).catch((err) => {
              toast.current.show({ severity: 'error', summary: 'Erreur', detail: err?.message, life: 3000 });
              setLoading(false);
            });
          }} />
        <div className="grid h-full m-0">
          <div className="col-12 lg:col-3 mb-4 flex flex-column align-items-center family-school-column">
            <div className="family-school-card">
              <img src={school?.avatar || "/images/school-empty-logo.svg"} alt="School Logo" className="family-school-avatar" />
              <span className="text-xl font-medium mt-3 text-center block">{school?.name}</span>
              <span className="text-sm text-600 mt-3 text-center">{school?.presentation}</span>
              <div className="text-center mt-3">
              <hr className="w-6" />
              <div className="text-sm text-500 mt-2">
                <div>{school?.address}</div>
                <div>{school?.city}, {school?.postal_code}</div>
                <div>{school?.phone}</div>
                <div>{school?.email}</div>
              </div>
            </div>
            </div>
          </div>
          <div className="col-12 lg:col-9 mb-8">
            <div className="family-content-column">
              <div className="family-hero-card mb-4">
                
                <div className="family-hero-title">{training?.name}</div>
                <div className="family-hero-subtitle">{training?.presentation}</div>
                <div className="family-hero-stats">
                  <Tag severity="info" icon="pi pi-users" value={`${registrations?.length || 0} enfant(s)`} />
                  <Tag severity="success" icon="pi pi-check-circle" value={`${enrolledCount} confirmé(s)`} />
                  {preregisteredCount > 0 && <Tag severity="warning" icon="pi pi-clock" value={`${preregisteredCount} à confirmer`} />}
                  {waitingCount > 0 && <Tag severity="secondary" icon="pi pi-hourglass" value={`${waitingCount} en attente`} />}
                  {unregisteredCount > 0 && <Tag severity="danger" icon="pi pi-times-circle" value={`${unregisteredCount} désinscrit(s)`} />}
                </div>
              </div>
              {renderAccordion()}
              {/*
              <div className="text-center mt-3">
                <hr className="w-6" />
                <div className="text-sm text-500 mt-2">
                  <div className="text-center mt-3 flex flex-column align-items-center justify-content-center" style={{ minHeight: '100px' }}>
                    <p>Si vous rencontrez un problème ou avez besoin de support sur le site, veuillez nous contacter à l'adresse e-mail suivante, en précisant votre nom et le souci rencontré :</p>
                    <div className="font-bold">
                      <Button
                        label="mon.ecole.arabe.com@gmail.com"
                        icon="pi pi-envelope"
                        className="p-button-text"
                        onClick={() => navigator.clipboard.writeText("mon.ecole.arabe.com@gmail.com")}
                        tooltip="Copier l'adresse e-mail"
                      />
                    </div>
                  </div>
                </div>
              </div>
              */}
            </div>
          </div>
        </div>

      {/* Mobile Navigation Bar */}
      <div className="family-mobile-nav-bar">
        {familySlotChangeEnabled && (
          <Button 
            icon="pi pi-sync"
            label="Demandes"
            className={`p-button-text p-button-plain w-full family-mobile-nav-button ${activeIndex === 0 ? "family-mobile-nav-button-active" : ""}`}
            onClick={() => handleNavClick(0)}
          />
        )}
        <Button 
          icon="pi pi-info-circle"
          label="Informations"
          className={`p-button-text p-button-plain w-full family-mobile-nav-button ${activeIndex === (familySlotChangeEnabled ? 1 : 0) ? "family-mobile-nav-button-active" : ""}`}
          onClick={() => handleNavClick(familySlotChangeEnabled ? 1 : 0)}
        />
        <Button 
          icon="pi pi-users"
          label="Responsables"
          className={`p-button-text p-button-plain w-full family-mobile-nav-button ${activeIndex === (familySlotChangeEnabled ? 2 : 1) ? "family-mobile-nav-button-active" : ""}`}
          onClick={() => handleNavClick(familySlotChangeEnabled ? 2 : 1)}
        />
        <Button 
          icon="pi pi-book"
          label="Élèves"
          className={`p-button-text p-button-plain w-full family-mobile-nav-button ${activeIndex === (familySlotChangeEnabled ? 3 : 2) ? "family-mobile-nav-button-active" : ""}`}
          onClick={() => handleNavClick(familySlotChangeEnabled ? 3 : 2)}
        />
        <Button 
          icon="pi pi-credit-card"
          label="Cotisations"
          className={`p-button-text p-button-plain w-full family-mobile-nav-button ${activeIndex === (familySlotChangeEnabled ? 4 : 3) ? "family-mobile-nav-button-active" : ""}`}
          onClick={() => handleNavClick(familySlotChangeEnabled ? 4 : 3)}
        />
      </div>
      </div>

      <Dialog
        header="Paiement à l'école"
        visible={paymentHelpVisible}
        style={{ width: "34rem", maxWidth: "95vw" }}
        onHide={() => setPaymentHelpVisible(false)}
      >
        <div className="flex flex-column gap-3">
          <div className="text-900 font-medium">
            {paymentHelpMethod ? `Méthode sélectionnée: ${getPaymentMethodLabel(paymentHelpMethod)}` : "Méthode sélectionnée"}
          </div>
          <div className="text-700">
            Merci de vous présenter à l'école pour effectuer ce paiement.
          </div>
          <div className="p-3 border-round bg-gray-50 border-1 border-gray-200">
            <div className="text-700">Contrat: <span className="font-medium">{selectedContractForHelp?.id || "-"}</span></div>
            <div className="text-700 mt-2">Montant restant: <span className="font-medium">€{formatAmount(getRemainingAmount(selectedContractForHelp))}</span></div>
          </div>
          <div className="text-600 text-sm">
            Pour finaliser, rapprochez-vous du secrétariat de l'école qui vous indiquera les modalités pratiques.
          </div>
          <div className="flex justify-content-end">
            <Button label="Fermer" onClick={() => setPaymentHelpVisible(false)} />
          </div>
        </div>
      </Dialog>

      <Dialog
        visible={showHelloAssoAmountModal}
        style={{ width: "38rem" }}
        onHide={() => setShowHelloAssoAmountModal(false)}
        maximized={window.innerWidth <= 768}
        modal
        closable
        closeOnEscape
        focusOnShow
        className="helloasso-amount-modal"
        breakpoints={{ '768px': '100vw' }}
        content={({ hide }) => (
          <div className="helloasso-modal-content">
            {/* Logo Section */}
            <img 
              src="https://cdn.prod.website-files.com/67164cc9484c7fb65c26915e/672e13f3d88bcd6f6fa5fdd0_Logo%20HA_white.svg"
              alt="HelloAsso Logo"
              className="helloasso-modal-logo"
              onError={(e) => {
                e.target.src = `${process.env.PUBLIC_URL}/images/logo-helloasso-150.png`;
              }}
            />

            {/* Description Text */}
            <div className="helloasso-modal-description">
              <span>
                Nous avons choisi HelloAsso pour réaliser votre paiement car ils prennent en charge les frais de transaction pour soutenir les associations.
              </span>
              <span className="helloasso-modal-description-highlight">
                100% de votre paiement ira bien à notre association.
              </span>
              <span>
                Vous pouvez aider HelloAsso dans sa mission en laissant une contribution volontaire et ainsi participer à leur seule source de revenus.
              </span>
            </div>

            {/* Amount Section */}
            <div>
              <div className="helloasso-modal-amount-label">Montant de votre cotisation :</div>
              <div className="helloasso-modal-amount-value">€{formatAmount(getRemainingAmount(selectedContractForAmount))}</div>
            </div>

            {/* Buttons */}
            <div className="helloasso-modal-button-container">
              <Button 
                label="Payer la totalité" 
                onClick={() => {
                  const maxAmount = getRemainingAmount(selectedContractForAmount);
                  if (maxAmount && maxAmount > 0) {
                    handlePayContract(selectedContractForAmount, "HELLOASSO", maxAmount, 1);
                  } else {
                    toast.current.show({
                      severity: "warn",
                      summary: "Montant invalide",
                      detail: "Le montant à payer est invalide.",
                      life: 3000,
                    });
                  }
                }}
                loading={startingHelloAssoForContractId === selectedContractForAmount?.id && startingHelloAssoInstallments === 1}
                className="helloasso-modal-button"
              />
              {(() => {
                const options = paymentSettings?.helloasso_installments_options || [];
                const maxAmount = getRemainingAmount(selectedContractForAmount);
                return options.filter(opt => opt > 1 && maxAmount >= opt * 10).map((opt) => (
                  <Button 
                    key={opt}
                    label={`Paiement en ${opt}X`}
                    onClick={() => {
                      if (maxAmount && maxAmount > 0) {
                        handlePayContract(selectedContractForAmount, "HELLOASSO", maxAmount, opt);
                      }
                    }}
                    loading={startingHelloAssoForContractId === selectedContractForAmount?.id && startingHelloAssoInstallments === opt}
                    className="helloasso-modal-button helloasso-modal-button-secondary"
                  />
                ));
              })()}
            </div>

            {/* Payment Method Icons */}
            <div className="helloasso-modal-payment-methods">
              <img 
                src={`${process.env.PUBLIC_URL}/images/payment-cb.svg`}
                alt="Carte Bancaire"
                onError={(e) => e.target.style.display = 'none'}
              />
              <img 
                src={`${process.env.PUBLIC_URL}/images/payment-mastercard.svg`}
                alt="MasterCard"
                onError={(e) => e.target.style.display = 'none'}
              />
              <img 
                src={`${process.env.PUBLIC_URL}/images/payment-visa.svg`}
                alt="Visa"
                onError={(e) => e.target.style.display = 'none'}
              />
            </div>

            {/* Cancel Button */}
            <button
              className="helloasso-modal-cancel"
              onClick={() => setShowHelloAssoAmountModal(false)}
            >
              Annuler
            </button>
          </div>
        )}
      />

      <Toast ref={toast} />
      <ConfirmPopup />
    </div >
  );
};

export default FamilyRegistration;